import React, { useState } from 'react'
import { QuestionCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import ListPageHeader from '@shared/ListPageHeader'
import OrderHoldList from '@shared/orders/OrderHoldList'
import OrderHoldConceptModal from '@shared/orders/OrderHoldConceptModal'
import { orderHoldService } from '@services/operator/orderHoldService'

export default function List() {
  const { t } = useTranslation()
  const { merchants } = useOperatorData()
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        items={['orders', 'orders.holds']}
        guideButton={
          <Tooltip title={t('concepts.order_holds.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
      />
      <OrderHoldList
        service={orderHoldService}
        role="operator"
        merchants={merchants}
      />
      <OrderHoldConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}
